import { createFileRoute } from "@tanstack/react-router";

import { PlaceList } from "@/features/office/places/list";
import { placeListSearchSchema } from "@/features/office/places/list/_configs/place-list-search-schema";

export const Route = createFileRoute("/office/places/all")({
  component: PlaceList,
  validateSearch: placeListSearchSchema,
});

export default function PlacesAll() {
  return <PlaceList />;
}
